import { Injectable } from '@angular/core';
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { Observable } from 'rxjs';

import { GroupInvite } from '../models/group-invite.model';

@Injectable({
  providedIn: 'root'
})
export class GroupInvitesService {
  constructor(
    private functions: Functions,
  ) { }

  public inviteUserToGroup$(
    userId: string | undefined,
    groupId: string,
    addAsGroupAdmin = false,
    addAsSuperGroupAdmin = false,
    email?: string,
    licenceNumber?: string,
  ): Observable<boolean> {
    const functionCall = httpsCallableData(this.functions, 'inviteUserToGroup') as (data: any) => Observable<boolean>;

    const payload: {
      userId?: string;
      groupId: string;
      addAsGroupAdmin: boolean;
      addAsSuperGroupAdmin: boolean;
      email?: string;
      licenceNumber?: string;
    } = {
      groupId,
      addAsGroupAdmin,
      addAsSuperGroupAdmin,
    };

    if (userId) {
      payload.userId = userId;
    }

    if (email) {
      payload.email = email;
    }

    if (licenceNumber) {
      payload.licenceNumber = licenceNumber;
    }

    return functionCall(payload);
  }

  public getGroupInvites$(groupId: string): Observable<GroupInvite[]> {
    const functionCall = httpsCallableData(this.functions, 'getGroupInvites') as (data: any) => Observable<GroupInvite[]>;

    return functionCall({
      groupId,
    });
  }

  public getPendingGroupInvites$(): Observable<GroupInvite[]> {
    const functionCall = httpsCallableData(this.functions, 'getPendingGroupInvites') as () => Observable<GroupInvite[]>;
    return functionCall();
  }

  public cancelGroupInvite$(inviteId: string): Observable<boolean> {
    const functionCall = httpsCallableData(this.functions, 'cancelGroupInvite') as (data: any) => Observable<boolean>;

    return functionCall({
      inviteId,
    });
  }

  public respondToGroupInvite$(inviteId: string, acceptsInvite: boolean): Observable<boolean> {
    const functionCall = httpsCallableData(this.functions, 'respondToGroupInvite') as (data: any) => Observable<boolean>;

    return functionCall({
      inviteId,
      acceptsInvite,
    });
  }
}
